<!--  -->
<template>
  <div class="tree main">
    <a-card :bordered="false" class="cate-lists">
      <a-spin :spinning="spinning">
        <div class="title">
          <div class="text">栏目权限</div>
          <div class="form">
            <a-form-model-item>
              <a-select
                style="width: 200px"
                :value="roleValue"
                @change="handleChange"
              >
                <a-select-option v-for="item in rolelist" :key="item.id">
                  {{ item.rolename }}
                </a-select-option>
              </a-select>
              <a-button type="primary" style="margin-left:15px" @click="submit"
                >确定</a-button
              >
            </a-form-model-item>
          </div>
        </div>
        <a-table
          :columns="columns"
          :dataSource="treeData"
          :rowKey="record => record.catid"
          :expandedRowKeys="expandedRowKeys"
          size="small"
          :pagination="false"
          @expand="expand"
          :row-selection="rowSelection"
        >
        </a-table>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
const columns = [
  {
    title: '栏目名称',
    dataIndex: 'catname',
    scopedSlots: { customRender: 'catname' }
  },
  {
    title: '栏目id',
    dataIndex: 'catid',
    width: 150,
    scopedSlots: { customRender: 'catid' }
  }
];
export default {
  components: {},
  data() {
    return {
      columns,
      setSiteInfo: {},
      siteLists: {},
      treeData: [],
      roleValue: '',
      rolelist: [],
      classCatid: [],
      spinning: true,
      allCatid: [],
      expandedRowKeys: [],
      selectedRowKeys: []
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: this.onSelectChange,
        selectedRowKeys
      };
    }
  },
  //方法集合
  created() {
    this.init();
    this.$message.config({
      top: '400px'
    });
    this.getRolelist();
  },
  methods: {
    getRolelist() {
      this.$http
        .post('/api/ucenter/rolelist', { page: 1, limit: 999 })
        .then(res => {
          if (res.data.state == 200) {
            let list = res.data.data;
            for (let i = 0; i < list.length; i++) {
              if (list[i].id < this.myrole_id) {
                list.splice(i, 1);
              }
              if (list[i].type < 0) {
                list.splice(i, 1);
              }
            }
            this.roleValue = list[0].id;
            this.rolelist = list;
            this.classCatid = list[0].config.catalist.split(',');
            this.getCateList();
          }
        });
    },
    handleChange(value) {
      this.roleValue = value;
      this.all = false;
      for (let i = 0; i < this.rolelist.length; i++) {
        if (
          value == this.rolelist[i].id &&
          this.rolelist[i].config.catalist.length > 0
        ) {
          this.check(this.rolelist[i].config.catalist.split(','));
        } else if (
          value == this.rolelist[i].id &&
          this.rolelist[i].config.catalist.length == 0
        ) {
          this.check([]);
        }
      }
    },
    init() {
      this.setSiteInfo = JSON.parse(localStorage.getItem('siteinfo'));
      this.siteLists = JSON.parse(localStorage.getItem('siteLists'));
    },
    async getCateList() {
      let res = await this.$http.post('/api/content/categorylist', {
        catclass: 1,
        limit: 9999
      });
      res.data.data.forEach(item => {
        this.allCatid.push(item.catid);
      });
      let key = [];
      key = this.toTree(res.data.data); //生成树
      this.treeData = this.treeKey(key); //添加属性
      this.check(this.classCatid);
      this.spinning = false;
    },
    /**
     * @function 筛选用户组下可查看的栏目
     * @param arr 该用户组下拥有权限的栏目数组
     */
    check(arr) {
      let list = [];
      this.allCatid.forEach(item => {
        arr.forEach(item2 => {
          if (item == item2) {
            list.push(item);
          }
        });
      });
      this.selectedRowKeys = list;
    },
    toTree(data) {
      let that = this;
      data.forEach(item => {
        delete item.children;
      });
      let map = {};
      data.forEach(item => {
        map[item.catid] = item;
      });
      let val = [];
      data.forEach(item => {
        let parent = map[item.parentid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      return val;
    },
    treeKey(data) {
      let val = [];
      function setName(obj, ide) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].title = obj[i].catname;
          obj[i].key = ide + '-' + i;
          obj[i].value = obj[i].catid;
          obj[i].label = obj[i].catname;
          if (obj[i].children) {
            setName(obj[i].children, obj[i].key);
          }
        }
        val = obj;
      }
      setName(data, '0');
      return val;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    submit() {
      let data = [];
      for (let i = 0; i < this.rolelist.length; i++) {
        if (this.roleValue == this.rolelist[i].id) {
          data = this.rolelist[i];
        }
      }
      let param = {
        description: data.description,
        id: data.id,
        rolename: data.rolename,
        type: data.type,
        catalist: this.selectedRowKeys.join(',')
      };
      this.$http.post('/api/ucenter/roleupdate', param).then(res => {
        if (res.data.state == 200) {
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
      });
    },
    expand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.catid);
      } else {
        let curr = this.expandedRowKeys.findIndex((current, index) => {
          return current === record.catid;
        });
        this.expandedRowKeys.splice(curr, 1);
      }
    }
  }
};
</script>
<style scoped>
.tree >>> .ant-table-row-expand-icon {
  border-color: #999;
}
.main {
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.cate-lists {
  /* width: 710px; */
  margin: 0 10px;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 600px;
}
.margin-l-5 {
  margin-left: 5px;
}

.icon {
  margin-right: 5px;
  cursor: pointer;
}
.icon:hover {
  color: #1890ff;
}
.title {
  position: relative;
  height: 60px;
  line-height: 60px;
}
.text {
  position: absolute;
  left: 10px;
  font-size: 18px;
}
.form {
  position: absolute;
  padding-top: 10px;
  left: 120px;
}
</style>
